import actionTypes from '../actionTypes';

export const FETCH_PERMISSIONS = actionTypes('FETCH_PERMISSIONS');
